module.exports = __webpack_public_path__ + "static/media/ach-logo-bank-transfer.a91a325c.webp";